import { render, staticRenderFns } from "./LinkInfoShort.vue?vue&type=template&id=59cf44cc&scoped=true&"
import script from "./LinkInfoShort.vue?vue&type=script&lang=js&"
export * from "./LinkInfoShort.vue?vue&type=script&lang=js&"
import style0 from "./LinkInfoShort.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LinkInfoShort.vue?vue&type=style&index=1&id=59cf44cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf44cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59cf44cc')) {
      api.createRecord('59cf44cc', component.options)
    } else {
      api.reload('59cf44cc', component.options)
    }
    module.hot.accept("./LinkInfoShort.vue?vue&type=template&id=59cf44cc&scoped=true&", function () {
      api.rerender('59cf44cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/LinkInfoShort.vue"
export default component.exports